import styled from '@emotion/styled'

export const AddDeductionComponentButtonWrapper = styled.div``
